import { Popover, TextField } from '@mui/material';
import { textFieldStyleProps } from './GridAndAxes/GridAndAxes';
import { SketchPicker } from 'react-color';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import { useState } from 'react';
import { handleDecimalInput, handleKeyDown } from '../CommonFunctions/CommonFunctions';

export const CustomBgColor = ({ id, backgroundColor, onChangeColorProps }: any) => {
  const [selectedId, setSelectedId] = useState<string>('');
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <div style={{ display: 'flex', gap: '10px', marginLeft: '10px' }}>
      <div
        title="Background Color"
        style={{
          height: '20px',
          width: '20px',
          backgroundColor: backgroundColor,
          color: backgroundColor,
          border: '2px solid darkgray',
          borderRadius: '4px',
        }}
        onClick={(e) => {
          setSelectedId(id);
          setAnchorEl(e.currentTarget);
        }}
      ></div>
      <Popover
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div id={id}>
          <SketchPicker
            color={backgroundColor}
            className="sketchPicker"
            width="16rem"
            onChange={(color) => {
              onChangeColorProps('backgroundColor', color.hex, selectedId);
            }}
          />
        </div>
      </Popover>
    </div>
  );
};

export const CustomFontAndBgColor = ({
  id,
  backgroundColor,
  from,
  fontColor,
  onChangeColorProps,
}: any) => {
  const [selectedId, setSelectedId] = useState<string>('');
  const [bgAnchorEl, setBgAnchorEl] = useState<HTMLElement | null>(null);
  const [fontAnchorEl, setFontAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <div style={{ display: 'flex', gap: '10px', marginLeft: '10px' }}>
      <div
        title={from === 'simpleCard' ? 'Highlight Color' : 'Background Color'}
        style={{
          height: '20px',
          width: '20px',
          backgroundColor: backgroundColor,
          color: backgroundColor,
          border: '2px solid darkgray',
          borderRadius: '4px',
        }}
        onClick={(e) => {
          setSelectedId(id);
          setBgAnchorEl(e.currentTarget);
        }}
      ></div>
      <Popover
        open={Boolean(bgAnchorEl)}
        onClose={() => setBgAnchorEl(null)}
        anchorEl={bgAnchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div id={id}>
          <SketchPicker
            color={backgroundColor}
            className="sketchPicker"
            width="16rem"
            onChangeComplete={(color) => {
              const { r, g, b, a } = color.rgb;
              const rgbaString = `rgba(${r},${g},${b},${a})`;
              onChangeColorProps('backgroundColor', rgbaString, selectedId);
            }}
          />
        </div>
      </Popover>

      <div
        title="Font Color"
        style={{
          height: '20px',
          width: '20px',
          backgroundColor: fontColor,
          color: fontColor,
          border: '2px solid darkgray',
          borderRadius: '4px',
        }}
        onClick={(e) => {
          setSelectedId(id);
          setFontAnchorEl(e.currentTarget);
        }}
      ></div>
      <Popover
        open={Boolean(fontAnchorEl)}
        onClose={() => setFontAnchorEl(null)}
        anchorEl={fontAnchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div id={id}>
          <SketchPicker
            color={fontColor}
            className="sketchPicker"
            width="16rem"
            onChangeComplete={(color) => {
              const { r, g, b, a } = color.rgb;
              const rgbaString = `rgba(${r},${g},${b},${a})`;
              onChangeColorProps('fontColor', rgbaString, selectedId);
            }}
          />
        </div>
      </Popover>
    </div>
  );
};

export const StyleButtons = ({
  isBold,
  isItalic,
  isUnderlined,
  onChangeStyleProps,
  iconColor,
}: any) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '10px',
      }}
    >
      <FormatBoldIcon
        onClick={() => {
          onChangeStyleProps('isBold', !isBold);
        }}
        sx={{
          height: '20px',
          width: '20px',
          border: '1px solid grey',
          borderRadius: '3px',
          color: iconColor || 'inherit',
          backgroundColor: isBold
            ? iconColor === 'white'
              ? 'rgba(255, 255, 255, 0.57)'
              : 'rgba(163, 162, 162, 1)'
            : 'none',
        }}
      />
      <FormatItalicIcon
        onClick={() => onChangeStyleProps('isItalic', !isItalic)}
        sx={{
          height: '20px',
          width: '20px',
          border: '1px solid grey',
          borderRadius: '3px',
          color: iconColor || 'inherit',
          backgroundColor: isItalic
            ? iconColor === 'white'
              ? 'rgba(255, 255, 255, 0.57)'
              : 'rgba(163, 162, 162, 1)'
            : 'none',
        }}
      />
      <FormatUnderlinedIcon
        onClick={() => onChangeStyleProps('isUnderlined', !isUnderlined)}
        sx={{
          height: '20px',
          width: '20px',
          border: '1px solid grey',
          borderRadius: '3px',
          color: iconColor || 'inherit',
          backgroundColor: isUnderlined
            ? iconColor === 'white'
              ? 'rgba(255, 255, 255, 0.57)'
              : 'rgba(163, 162, 162, 1)'
            : 'none',
        }}
      />
    </div>
  );
};

export const checkIsConditionSatisfied = (formatsArray: any, dmValue: number) => {
  const updatedArray = formatsArray.map((item: any) => {
    let el = JSON.parse(JSON.stringify(item));
    if (el.conditionType === 1) {
      if (dmValue > Number(el.target) && el.target) {
        el.isConditionSatisfied = true;
      } else {
        el.isConditionSatisfied = false;
      }
    }
    if (el.conditionType === 2) {
      if (dmValue < Number(el.target) && el.target) {
        el.isConditionSatisfied = true;
      } else {
        el.isConditionSatisfied = false;
      }
    }
    if (el.conditionType === 3) {
      if (dmValue >= Number(el.target) && el.target) {
        el.isConditionSatisfied = true;
      } else {
        el.isConditionSatisfied = false;
      }
    }
    if (el.conditionType === 4) {
      if (dmValue <= Number(el.target) && el.target) {
        el.isConditionSatisfied = true;
      } else {
        el.isConditionSatisfied = false;
      }
    }
    if (el.conditionType === 5) {
      if (dmValue === Number(el.target) && el.target) {
        el.isConditionSatisfied = true;
      } else {
        el.isConditionSatisfied = false;
      }
    }
    if (el.conditionType === 6) {
      if (dmValue !== Number(el.target) && el.target) {
        el.isConditionSatisfied = true;
      } else {
        el.isConditionSatisfied = false;
      }
    }
    if (el.conditionType === 7) {
      if (el.target && dmValue >= Number(el.minValue) && dmValue <= Number(el.maxValue)) {
        el.isConditionSatisfied = true;
      } else {
        el.isConditionSatisfied = false;
      }
    }
    return el;
  });

  return updatedArray;
};

export const conditionTypes = [
  { id: 1, value: '> Greater than' },
  { id: 2, value: '< Less than' },
  { id: 3, value: '>= Greater than or Equal to' },
  { id: 4, value: '<= Less than or Equal to' },
  { id: 5, value: '= Equal to' },
  { id: 6, value: '<> Not Equal to' },
  { id: 7, value: '>= Between <=' },
];

export const GetInputField = ({
  condition,
  onChangeValueProps,
  iconColor,
  backgroundColor,
}: any) => {
  return (
    <>
      {condition.conditionType === 7 ? (
        <>
          <div style={{ color: iconColor ? iconColor : '#404040' }}>Min Value</div>

          <TextField
            value={condition.minValue || ''}
            variant="outlined"
            type="text"
            onChange={(e) => {
              e.preventDefault();
              // here we are setting value only when value is number or a decimal number to allow decimal(only once) and number.
              let isInputValid = handleDecimalInput(e.target.value);
              isInputValid && onChangeValueProps('minValue', e.target.value);
            }}
            sx={{
              marginTop: '5px',
              '& .MuiInputBase-root': {
                width: '100% !important',
                margin: '0 auto 0.5rem auto !important',
                backgroundColor: backgroundColor || 'white',
              },
              '& .MuiInputBase-input': {
                color: iconColor || '#404040',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: iconColor || '#2bb9bb',
              },
              '& .MuiOutlinedInput-input': {
                padding: '16.5px 14px', // Consistent padding for all browsers
              },
              // Firefox-specific styling
              '@supports (-moz-appearance: none)': {
                '& .MuiOutlinedInput-input': {
                  padding: '16.5px 2px 16.5px 14px',
                },
              },
            }}
            InputProps={{ ...textFieldStyleProps }}
            fullWidth
          />
          <div style={{ color: iconColor ? iconColor : '#404040' }}>Max Value</div>

          <TextField
            value={condition.maxValue}
            variant="outlined"
            type="text"
            onChange={(e) => {
              e.preventDefault();
              // here we are setting value only when value is number or a decimal number to allow decimal(only once) and number.
              let isInputValid = handleDecimalInput(e.target.value);
              isInputValid && onChangeValueProps('maxValue', e.target.value);
            }}
            sx={{
              marginTop: '5px',
              '& .MuiInputBase-root': {
                width: '100% !important',
                margin: '0 auto 0.5rem auto !important',
                backgroundColor: backgroundColor || 'white',
              },
              '& .MuiInputBase-input': {
                color: iconColor || '#404040',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: iconColor || '#2bb9bb',
              },
              '& .MuiOutlinedInput-input': {
                padding: '16.5px 14px', // Consistent padding for all browsers
              },
              // Firefox-specific styling
              '@supports (-moz-appearance: none)': {
                '& .MuiOutlinedInput-input': {
                  padding: '16.5px 2px 16.5px 14px',
                },
              },
            }}
            InputProps={{ ...textFieldStyleProps }}
            fullWidth
          />
        </>
      ) : (
        <>
          <div style={{ color: iconColor ? iconColor : '#404040' }}>Target Value</div>

          <TextField
            value={condition.target}
            variant="outlined"
            type="text"
            onChange={(e) => {
              e.preventDefault();
              // here we are setting value only when value is number or a decimal number to allow decimal(only once) and number.
              let isInputValid = handleDecimalInput(e.target.value);
              isInputValid && onChangeValueProps('target', e.target.value);
            }}
            onBlur={(e: any) => {
              onChangeValueProps('target', e.target.value);
            }}
            InputProps={{ ...textFieldStyleProps }}
            sx={{
              marginTop: '5px',
              '& .MuiInputBase-root': {
                width: '100% !important',
                margin: '0 auto 0.5rem auto !important',
                backgroundColor: backgroundColor || 'white',
              },
              '& .MuiInputBase-input': {
                color: iconColor || '#404040',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: iconColor || '#2bb9bb',
              },
              '& .MuiOutlinedInput-input': {
                padding: '16.5px 14px', // Consistent padding for all browsers
              },
              // Firefox-specific styling
              '@supports (-moz-appearance: none)': {
                '& .MuiOutlinedInput-input': {
                  padding: '16.5px 2px 16.5px 14px',
                },
              },
            }}
            fullWidth
          />
        </>
      )}
    </>
  );
};
